import { useEffect, useState } from 'react';
import { getLoginFormOptions } from '../../../services/login/Login.api';

function useLoginOptions({ seatFormation }) {
  const [options, setOptions] = useState({});

  const fetchOptions = async () => {
    const res = await getLoginFormOptions();
    if (res.status === 'success') {
      res.data.phoneCodes = res.data.countries.map((item) => ({
        label: item.country_phone_code,
        value: item.id,
      }));
      setOptions(res.data);
    }
  };

  useEffect(() => {
    if (seatFormation === 'book') fetchOptions();
  }, [seatFormation]);

  return { options, fetchOptions };
}

export default useLoginOptions;
